import { useEffect } from 'react';
import ReactHtmlParser from '@orrisroot/react-html-parser';
import type { Dispatch, SetStateAction } from 'react';

import useGlobalStore from '~/stores/global/useGlobalStore';

import { Container, Message } from './Alert.styled';

type IProps = {
  type: 'success' | 'info' | 'warning' | 'error' | undefined;
  message: string;
  timeout: number;
  show: boolean;
  setShow?: Dispatch<SetStateAction<boolean>>;
};
export default function Alert({ type, message, timeout, show, setShow }: IProps) {
  let timeToClose = timeout;

  if (!timeToClose || Number(timeToClose) <= 0) timeToClose = 5000;
  const { disableAlert } = useGlobalStore();

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        if (setShow) {
          setShow(false);
        }
        disableAlert();
      }, timeout);
    }
  }, [disableAlert, setShow, show, timeout]);
  return (
    <Container className={show ? 'active' : ''} onClick={() => disableAlert()}>
      <Message message={ReactHtmlParser(message)} type={type} showIcon />
    </Container>
  );
}
